'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { usePathname } from '@/core/i18n/navigation';
import { Button } from '@/shared/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/shared/components/ui/dialog';
import { Drawer, DrawerClose, DrawerContent, DrawerDescription, DrawerFooter, DrawerHeader, DrawerTitle } from '@/shared/components/ui/drawer';
import { useAppContext } from '@/shared/contexts/app';
import { useMediaQuery } from '@/shared/hooks/use-media-query';
import { resolveSignModalCallbackUrl } from './sign-callback';
import { SignInForm } from './sign-in-form';
export function SignModal(t0) {
  const $ = _c(50);
  const {
    callbackUrl
  } = t0;
  const t = useTranslations("common.sign");
  const pathname = usePathname();
  const {
    isShowSignModal,
    setIsShowSignModal,
    configs
  } = useAppContext();
  const isDesktop = useMediaQuery("(min-width: 768px)");
  let t1;
  if ($[0] !== callbackUrl || $[1] !== pathname) {
    t1 = resolveSignModalCallbackUrl({
      callbackUrl,
      pathname
    });
    $[0] = callbackUrl;
    $[1] = pathname;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const resolvedCallbackUrl = t1;
  if (isDesktop) {
    let t2;
    if ($[3] !== t) {
      t2 = t("sign_in_title");
      $[3] = t;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== t2) {
      t3 = <DialogTitle>{t2}</DialogTitle>;
      $[5] = t2;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    const t4 = configs.initial_credits_amount || "0";
    let t5;
    if ($[7] !== t || $[8] !== t4) {
      t5 = t("sign_in_description", {
        initial_credits_amount: t4
      });
      $[7] = t;
      $[8] = t4;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    let t6;
    if ($[10] !== t5) {
      t6 = <DialogDescription>{t5}</DialogDescription>;
      $[10] = t5;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== t3 || $[13] !== t6) {
      t7 = <DialogHeader>{t3}{t6}</DialogHeader>;
      $[12] = t3;
      $[13] = t6;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    let t8;
    if ($[15] !== resolvedCallbackUrl) {
      t8 = <SignInForm callbackUrl={resolvedCallbackUrl} />;
      $[15] = resolvedCallbackUrl;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    let t9;
    if ($[17] !== t7 || $[18] !== t8) {
      t9 = <DialogContent className="sm:max-w-[425px]">{t7}{t8}</DialogContent>;
      $[17] = t7;
      $[18] = t8;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    let t10;
    if ($[20] !== isShowSignModal || $[21] !== setIsShowSignModal || $[22] !== t9) {
      t10 = <Dialog open={isShowSignModal} onOpenChange={setIsShowSignModal}>{t9}</Dialog>;
      $[20] = isShowSignModal;
      $[21] = setIsShowSignModal;
      $[22] = t9;
      $[23] = t10;
    } else {
      t10 = $[23];
    }
    return t10;
  }
  let t2;
  if ($[24] !== t) {
    t2 = t("sign_in_title");
    $[24] = t;
    $[25] = t2;
  } else {
    t2 = $[25];
  }
  let t3;
  if ($[26] !== t2) {
    t3 = <DrawerTitle>{t2}</DrawerTitle>;
    $[26] = t2;
    $[27] = t3;
  } else {
    t3 = $[27];
  }
  const t4 = configs.initial_credits_amount || "0";
  let t5;
  if ($[28] !== t || $[29] !== t4) {
    t5 = t("sign_in_description", {
      initial_credits_amount: t4
    });
    $[28] = t;
    $[29] = t4;
    $[30] = t5;
  } else {
    t5 = $[30];
  }
  let t6;
  if ($[31] !== t5) {
    t6 = <DrawerDescription>{t5}</DrawerDescription>;
    $[31] = t5;
    $[32] = t6;
  } else {
    t6 = $[32];
  }
  let t7;
  if ($[33] !== t3 || $[34] !== t6) {
    t7 = <DrawerHeader className="text-left">{t3}{t6}</DrawerHeader>;
    $[33] = t3;
    $[34] = t6;
    $[35] = t7;
  } else {
    t7 = $[35];
  }
  let t8;
  if ($[36] !== resolvedCallbackUrl) {
    t8 = <SignInForm callbackUrl={resolvedCallbackUrl} className="mt-8 px-4" />;
    $[36] = resolvedCallbackUrl;
    $[37] = t8;
  } else {
    t8 = $[37];
  }
  let t9;
  if ($[38] !== t) {
    t9 = t("cancel_title");
    $[38] = t;
    $[39] = t9;
  } else {
    t9 = $[39];
  }
  let t10;
  if ($[40] !== t9) {
    t10 = <DrawerFooter className="pt-4"><DrawerClose asChild={true}><Button variant="outline">{t9}</Button></DrawerClose></DrawerFooter>;
    $[40] = t9;
    $[41] = t10;
  } else {
    t10 = $[41];
  }
  let t11;
  if ($[42] !== t10 || $[43] !== t7 || $[44] !== t8) {
    t11 = <DrawerContent>{t7}{t8}{t10}</DrawerContent>;
    $[42] = t10;
    $[43] = t7;
    $[44] = t8;
    $[45] = t11;
  } else {
    t11 = $[45];
  }
  let t12;
  if ($[46] !== isShowSignModal || $[47] !== setIsShowSignModal || $[48] !== t11) {
    t12 = <Drawer open={isShowSignModal} onOpenChange={setIsShowSignModal}>{t11}</Drawer>;
    $[46] = isShowSignModal;
    $[47] = setIsShowSignModal;
    $[48] = t11;
    $[49] = t12;
  } else {
    t12 = $[49];
  }
  return t12;
}